/**
 *
 * key
 *
 */

 const key = 'ZXZlbnRXaXNlRGF0YUNvcHk='

 export default key

